<template>
  <div :key="gridSkeletonKey" class="grid-x grid-margin-x">
    <div class="cell small-6 medium-4 large-3">
      <!-- Product Card -->
      <SkeletonProductCard />
    </div>
    <div class="cell small-6 medium-4 large-3">
      <!-- Product Card -->
      <SkeletonProductCard />
    </div>
    <div class="cell small-6 medium-4 large-3 show-for-medium">
      <!-- Product Card -->
      <SkeletonProductCard />
    </div>
    <div class="cell small-6 medium-4 large-3 show-for-large">
      <!-- Product Card -->
      <SkeletonProductCard />
    </div>
  </div>
</template>

<script setup>
const gridSkeletonKey = ref(1);

onMounted(() => {
  gridSkeletonKey.value += 1;
});
</script>
